import React, { useState } from 'react';
import { NextPage } from 'next';
import useProducts from '../../hooks/use-products';
import TrainingMaterialsLayout from '../../components/@bookstore/bookstore-training-layout';
import BookstoreProductGrid from '../../components/@bookstore/bookstore-product-grid';
import Spacer from "../../shared/tds/components/@atoms/spacer";
import Spacings from "../../shared/tds/components/tokens/layout/spacings";
import BookstoreTrainingRequest from "../../components/@bookstore/bookstore-training-request";

const TrainingMaterialsLiteraturePage: NextPage = () => {
  const [pageIndex, setPageIndex] = useState(1);

  const { data, loading, error } = useProducts({
    conditions: [
      { code: 'status', namespace: '', value: 'ACTIVE' },
      { code: 'itemclass', namespace: '', value: 'OWNER' },
      { code: 'itemclass', namespace: '', value: 'SERVICE' },
      { code: 'itemclass', namespace: '', value: 'PARTS' },
      { code: 'itemtype', namespace: '', value: 'Training Literature' },
      { code: 'purchaseoption', namespace: '', value: 'consumer' },
      { code: 'purchaseoption', namespace: '', value: 'internal_access' },
      { code: 'purchaseoption', namespace: '', value: 'off' },
    ],
    page: pageIndex - 1,
    size: 12,
    sort: 'data.created.dsc',
  });

  if (typeof window === 'undefined') {
    return null;
  }

  const component = (children) => (
    <TrainingMaterialsLayout>
      {children}
      {/* language=CSS */}
      <style jsx>{`
        :global(.product-search-filter) {
          margin-top: 2rem;
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 400;
          font-size: 14px;
          padding: 0 2rem;
        }
      `}</style>
    </TrainingMaterialsLayout>
  );

  if (loading || error) {
    return component(
      <p className="product-search-filter">
        Searching for products, please wait a minute.
      </p>
    );
  } else if (!data || data.products.content.length === 0) {
    return component(
      <p className="product-search-filter">
        Your search did not return any matching results. Please try a different
        search.
      </p>
    );
  } else {
    return component(
      <>
        <BookstoreProductGrid
          products={data.products}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
        />
        <Spacer spacing={Spacings.xxxLarge} orientation="vertical"/>
        <BookstoreTrainingRequest/>
      </>
    );
  }
};

export default TrainingMaterialsLiteraturePage;
